import { FLAGS } from '@/core/flags.js';
import { router } from '@/main.js';
import moment from 'moment/moment.js';
import { inProductionEnv } from '@/core/helpers/utils.js';
import { mapActions } from 'vuex';
import vm from '@/main.js';

let unityMessageHandler = null;

export default {
    namespaced: true,
    state: {
        iframe: null,
        priceOptionFromUnity: null,
    },
    getters: {
        jwt() {
            return localStorage.getItem('authToken');
        },
        unityIframeSrc(state, getters, rootState, rootGetters) {
            // if (!rootState.user) {
            //     // Wait for the user to get loaded.
            //     return null;
            // }
            const version = moment().format('DD-MM-YYYY-HH-mm');

            // Get the current window's origin (e.g., "https://qa.99math.com")
            const parentOrigin = window.location.origin;
            // URL-encode the origin to safely include it as a query parameter value
            const encodedParentOrigin = encodeURIComponent(parentOrigin);

            const baseUrl = inProductionEnv()
                ? 'https://game.prod.99math.com/WebGL/index.html'
                : 'https://pets.qa.99math.com/WebGL/index.html';
            return `${baseUrl}?userToken=${getters.jwt}&mp=${rootGetters.subscribedUser}&parentOrigin=${encodedParentOrigin}&version=${version}`;
        },
        renderPetsGame(state, getters) {
            if (
                [
                    'home-game.v10.join-class',
                    'home-game.v10.burger',
                    'home-game.v10.assignments',
                ].includes(router.currentRoute.value?.name)
            ) {
                return false;
            }
            return getters.userHasPetsGame;
        },
        userHasPetsGame(state, getters, rootState, rootGetters) {
            return rootGetters.user?.flags?.[FLAGS.PETS_GAME];
        },
        hasUnityStripePriceOption(state) {
            return state.priceOptionFromUnity;
        },
    },
    mutations: {
        setIframe(state, value) {
            state.iframe = value;
        },
        setUnityPriceOptions(state, value) {
            state.priceOptionFromUnity = value;
        },
    },
    actions: {
        ...mapActions('v2/unityGame', [
            'listenToUnityMessages',
            'removeUnityMessageListener',
        ]),
        listenToUnityMessages({ dispatch }) {
            if (unityMessageHandler) {
                return;
            }

            unityMessageHandler = (event) => {
                dispatch('handleUnityMessage', event);
            };

            window.addEventListener('message', unityMessageHandler);
        },
        removeUnityMessageListener(store) {
            if (unityMessageHandler) {
                window.removeEventListener('message', unityMessageHandler);
                unityMessageHandler = null;
            }
        },
        handleUnityMessage(store, event) {
            const senderOrigin = event.origin;

            let isOriginAllowed = false;
            for (const regex of [
                /^https?:\/\/localhost(:\d+)?$/, // Matches localhost with any port
                /^https?:\/\/([a-zA-Z0-9-]+\.)*99math\.com$/, // Matches *.99math.com
            ]) {
                if (regex.test(senderOrigin)) {
                    isOriginAllowed = true;
                    break; // Found a match, no need to check further
                }
            }

            if (!isOriginAllowed) {
                console.warn(
                    `Message received from disallowed origin: ${senderOrigin}. Expected localhost:* or *.99math.com. Message ignored.`,
                );
                return;
            }

            // console.debug(
            //     'Message received from allowed origin:',
            //     senderOrigin,
            // );
            // console.debug('Message data:', event.data);

            let messageData = event.data;
            try {
                const parsedData = JSON.parse(messageData);
                messageData = parsedData;

                if (messageData.event === 'menuClicked') {
                    console.debug('Menu icon was clicked!');
                    router.push({ name: 'home-game.v10.burger' });
                } else if (messageData.event === 'openPaymentView') {
                    const priceOptionId = messageData.data;
                    console.log(`Open payment modal with ${priceOptionId}`);
                    vm.$emitter.emit(
                        'openHomeGamePaymentModal',
                        `unityGame-${priceOptionId}`,
                    );
                } else {
                    console.warn(
                        `Message received from Unity, but no handler defined: ${messageData}`,
                    );
                }
            } catch (e) {
                console.error(`Error parsing JSON: ${e}`);
            }
        },
        postMessageToUnity(context, message) {
            context.state.iframe.contentWindow.postMessage(message, '*');
        },
    },
};
